var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNextButtoninline = function SvgNextButtoninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14 9.621.852 17.867c-.469.294-.849.086-.849-.466V.59c0-.552.386-.756.85-.466L14 8.371V.993A.994.994 0 0 1 15 0c.552 0 1 .445 1 .993v16.006a.994.994 0 0 1-1 .993c-.552 0-1-.445-1-.993V9.621z"
  })));
};
export default SvgNextButtoninline;